import styled from 'styled-components';
import { spacer4 } from '@spotify-internal/encore-foundation';
export default styled.span.withConfig({
  displayName: "Popover",
  componentId: "sc-4xru43-0"
})(["display:inline-flex;margin-left:", ";"], spacer4);